module.exports = {
  page: {
    title: 'OpenBasement',
    subtitle: 'nie-sieć anty-społecznościowa',
    footer: '¬©2016 załoga OpenBasement oraz (wyimaginowani) przyjaciele',
    about: 'O nas'
  },

  events: {
    title: 'Wydarzenia',
    empty: 'brak wydarzeń',

    stillAlive: 'Dnia %{date} nadal żyłeś/aś'
  },

  interactions: {
    title: 'Interakcje',
    empty: 'brak interakcji',

    'last-meeting': 'Ostatnie spotkanie: %{time}',
    'meetings-total': 'Łącznie spotkań: %{total}'
  },

  notifications: {
    title: 'Powiadomienia',
    empty: 'brak nowych powiadomień',

    '1th-entry': 'Gratki! Pierwszy wpis!',
    '2th-entry': 'I jeszcze jeden!',
    '5th-entry': 'Widzę, że łapiesz',
    '10th-entry': 'Lubisz spamować, czyż nie?',
    '20th-entry': 'Sporo wiadomości',
    '50th-entry': 'Tyle wiadomości do samego siebie - jesteś taaaki/a samotny/a',
    '100th-entry': '100 wiadomości których nikt nie przeczyta',
    '200th-entry': '200 wiadomości do nikogo - może jednak flaszka?',
    '500th-entry': '500 postów. Masz poważny problem',
    '1000th-entry': 'Dobra, zamykam się. To cię tylko nakręca.',

    'moody-day': 'Dzisiaj jesteś strasznie humorzasty/a?'
  },

  journal: {
    meeting: 'spotkanie',
    mood: 'nastrój',
    note: 'notka',
    hint: 'Możesz użyć'
  },

  profile: {
    menu: 'Profil',
    title: 'Twój profil',
    content: 'Nikogo to nie obchodzi.'
  },

  friends: {
    menu: 'Przyjaciele',
    title: 'Twoi przyjaciele',
    content: 'Nie masz żadnych, mieszkasz w piwnicy, pamiętasz?.'
  },

  settings: {
    menu: 'Ustawienia',
    title: 'Twoje ustawienia',
    content: 'Nie obchodzisz nas wystarczająco abyśmy dali jakieś sensowne.',

    locale: {
      en: 'English',
      pl: 'Polski'
    }
  },

  welcome: {
    title: 'Witaj w swojej Piwnicy!',
    'content-1':
      'Wiemy, że nie masz przyjaciów i strasznie cierpisz, przy każdym gównianym poście na FB.',
    'content-2':
      'Wiemy także, że nie masz ochoty spamować wszystkich każdą myślą, krytyczny draniu.',
    'content-3':
      'Ale nie płacz już. Bo stworzyliśmy tą wyjątkową, wirtualną Piwnicę.',
    'content-4':
      'Zapewnia ci ona:',
    'content-5':
      'brak rejestracji - nie musisz tracić czasu, aby się gdziekolwiek rejestrować! Jest tak gdyż...',
    'content-6':
      'nie odpytujemy serwera - wszystko co robisz odbywa się i jest przechowywane lokalnie! To oznacza...',
    'content-7':
      'brak szpiegowania i reklam - wszystkie zwyrolstwa jakie napiszesz pozostaną na zawsze prywatne.',
    'content-8':
      'markdown i emojione - abyś mógł pisać piękne posty, których nikt nie przeczyta!',
    'content-9':
      'I w końcu pasek boczny - którzy będzie z ciebie jechał. Bo może.'
  }
};



/** WEBPACK FOOTER **
 ** ./src/i18n/locales/pl.js
 **/